import { UpdateIdCompletedInitGetRequestModel } from "@/features/user/services/update-id-completed-model";
import { UpdateIdCompletedApi } from "@/features/user/services/update-id-completed-api";

// 利用者ID更新完了ページ表示前処理
export class UpdateIdCompletedService {
  private updateIdCompletedApi = new UpdateIdCompletedApi();

  /**
   * 利用者ID更新完了ページ表示前処理API実行
   */
  public async updateIdCompletedInit(param: UpdateIdCompletedInitGetRequestModel) {
    return await this.updateIdCompletedApi.updateIdCompletedInit(param);
  }
}
